import { render, staticRenderFns } from "./ItemCodeTable.vue?vue&type=template&id=72b0041b"
import script from "./ItemCodeTable.vue?vue&type=script&lang=js"
export * from "./ItemCodeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports